var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"list-group-item",attrs:{"href":"#item-1-1","data-toggle":"collapse"}},[_vm._v("\n        User foldout row "+_vm._s(_vm.item.email)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }